/** The texts of sites' cloud drives and Nextclouds (STO-28, STO-29, STO-20), spread into the app's dictionaries (`lib/i18n.tsx`). */
export const cloudEn = {
  cloudHint:
    'You grant the platform access once, on the service’s own page. The platform keeps the grant encrypted, reaches the drive itself and passes files between it and the users it permits, as with the site’s bucket. On Google Drive it sees only the folder it makes; on Dropbox only its app folder. The site’s agreement with the service governs where the files are kept.',
  cloudService: 'Service',
  cloudFolder: 'Folder in the Drive',
  cloudAuthorize: 'Grant access and add',
  cloudAuthorizeAgain: 'Grant access again',
  cloudDeclined: 'Access to the cloud drive was not granted.',
  cloudFailed: 'The cloud drive was not added: {reason}',
  cloud_gdrive: 'Google Drive',
  cloud_dropbox: 'Dropbox',
  cloud_nextcloud: 'Nextcloud',
  nextcloudHint:
    'You log in once, on the Nextcloud’s own page. The platform receives an app password, never the account’s password, keeps it encrypted, reaches the folder itself and passes files between it and the users it permits, as with the site’s bucket. The Nextcloud lists the app password among the account’s devices, where the site can revoke it; removing the location deletes it.',
  nextcloudAccount: 'The login reaches every file of the account, not only this folder. Log in with an account your site keeps for the platform.',
  nextcloudAddress: 'Address of the Nextcloud',
  nextcloudFolder: 'Folder in the Nextcloud',
  nextcloudLogin: 'Log in and add',
  nextcloudLoginAgain: 'Log in again',
  nextcloudWaiting: 'Log in and grant access on the Nextcloud’s page; this page waits.',
  nextcloudOpen: 'Open the login page',
}

export const cloudDe: Record<keyof typeof cloudEn, string> = {
  cloudHint:
    'Sie geben der Plattform einmal Zugriff, auf der Seite des Dienstes selbst. Die Plattform bewahrt die Freigabe verschlüsselt auf, erreicht den Speicher selbst und reicht Dateien zwischen ihm und den berechtigten Personen weiter, wie beim Bucket des Standorts. Bei Google Drive sieht sie nur den Ordner, den sie anlegt, bei Dropbox nur ihren App-Ordner. Wo die Dateien liegen, regelt der Vertrag des Standorts mit dem Dienst.',
  cloudService: 'Dienst',
  cloudFolder: 'Ordner im Drive',
  cloudAuthorize: 'Zugriff geben und hinzufügen',
  cloudAuthorizeAgain: 'Zugriff erneut geben',
  cloudDeclined: 'Der Zugriff auf den Cloud-Speicher wurde nicht gegeben.',
  cloudFailed: 'Der Cloud-Speicher wurde nicht hinzugefügt: {reason}',
  cloud_gdrive: 'Google Drive',
  cloud_dropbox: 'Dropbox',
  cloud_nextcloud: 'Nextcloud',
  nextcloudHint:
    'Sie melden sich einmal an, auf der Seite der Nextcloud selbst. Die Plattform erhält ein App-Passwort, nie das Passwort des Kontos, bewahrt es verschlüsselt auf, erreicht den Ordner selbst und reicht Dateien zwischen ihm und den berechtigten Personen weiter, wie beim Bucket des Standorts. Die Nextcloud führt das App-Passwort unter den Geräten des Kontos, wo der Standort es widerrufen kann; wird der Speicherort entfernt, wird es gelöscht.',
  nextcloudAccount: 'Die Anmeldung erreicht jede Datei des Kontos, nicht nur diesen Ordner. Melden Sie sich mit einem Konto an, das Ihr Standort für die Plattform führt.',
  nextcloudAddress: 'Adresse der Nextcloud',
  nextcloudFolder: 'Ordner in der Nextcloud',
  nextcloudLogin: 'Anmelden und hinzufügen',
  nextcloudLoginAgain: 'Erneut anmelden',
  nextcloudWaiting: 'Melden Sie sich auf der Seite der Nextcloud an und geben Sie Zugriff; diese Seite wartet.',
  nextcloudOpen: 'Anmeldeseite öffnen',
}
